import { H2, L, Note, P, Ul } from '@/features/guide/prose'

export function SetupBranchEn() {
  return (
    <>
      <P>
        Go to romi.io.vn/restaurant-url (replace “restaurant-url” with your real URL name) and log in, or log in and open the restaurant through{' '}
        <L k="nav.myRestaurants" />. Open a branch to reach the branch page, then press <L k="landing.manageBranch" />.
      </P>
      <P>
        There are 6 branch setup pages: <L k="nav.branchSettings" />, <L k="nav.branchMenu" />, <L k="nav.statistics" />, <L k="nav.staff" />,{' '}
        <L k="nav.tables" /> and <L k="nav.branchInfo" />.
      </P>
      <Note>
        <L k="role.manager" /> and <L k="role.superuser" /> accounts see all 6; an <L k="role.admin" /> sees 5 (no <L k="nav.branchInfo" />).
      </Note>
      <H2>Branch settings</H2>
      <Ul>
        <li>
          <L k="branchSettings.openShop" /> / <L k="branchSettings.closeShop" />: when closed, customers cannot order; open it at the start of the day.
        </li>
        <li>
          <L k="branchSettings.mode" />: <L k="branchSettings.mode.open" />; <L k="branchSettings.mode.login" />; <L k="branchSettings.mode.closed" />, so only
          staff can create orders. Customers who scan a QR code in the closed mode see a notice and are sent to the branch page.
        </li>
        <li>
          The open mode adds <L k="branchSettings.expiry" />: a customer’s order shows the status <L k="track.status.sent" /> and expires automatically after
          that many minutes unless staff move it to <L k="track.status.confirmed" />. Default 10.
        </li>
        <li>
          The login mode adds <L k="branchSettings.cap" />: each logged-in account can hold at most that many active orders (<L k="track.status.confirmed" />,{' '}
          <L k="track.status.processing" /> or <L k="track.status.ready" />) at the same time. Default 2.
        </li>
        <li>
          <L k="branchSettings.pinGate" />: every order then needs the PIN before it is sent, which makes sure only customers present at the branch can order.
          Staff can read the current PIN at the top of the <L k="nav.queue" /> page. Change it regularly.
        </li>
        <li>
          <L k="branchSettings.deliveryAddress" />: adds a free-text field to take-away orders for a delivery address or a table number. Use it when the branch
          does not manage table sessions and every order at a table is paid separately.
        </li>
      </Ul>
      <H2>Branch menu</H2>
      <P>
        Shows the restaurant’s menu (created on the restaurant’s <L k="nav.menu" /> page). A branch can only change three things per item:
      </P>
      <Ul>
        <li>
          <L k="branchMenu.price" />: a branch-specific price (for example, a branch in a large shopping mall may raise prices to cover the rent). Leave it
          empty to use the base price.
        </li>
        <li>
          <L k="branchMenu.stock" />: optional, for items with a limited daily stock. When it reaches 0 the item shows as sold out and cannot be ordered.
        </li>
        <li>
          <L k="branchMenu.available" />: uncheck when the item is out of stock or not offered at this branch.
        </li>
      </Ul>
      <H2>Statistics</H2>
      <P>Shows the branch’s figures.</P>
      <H2>Staff</H2>
      <P>
        Manages the branch’s staff accounts. Search by the exact phone number or email of a registered Romi account and press <L k="staff.add" />.
      </P>
      <H2>Tables</H2>
      <Ul>
        <li>
          Only needed when you manage table sessions, that is, a table can order several times (several orders) and all of them are billed together when the
          customers pay.
        </li>
        <li>
          If every order is paid separately, you do not need tables. Consider the take-away QR code and turn on <L k="branchSettings.deliveryAddress" /> so
          customers can type the table they are sitting at.
        </li>
      </Ul>
      <P>
        The QR buttons here show the QR code for each target: <L k="tables.printQr.restaurant" />, <L k="tables.printQr.branch" />,{' '}
        <L k="tables.printQr.take_away" />, and one <L k="tables.print" /> per table for dine-in orders. Printing is built in.
      </P>
      <H2>Branch info</H2>
      <P>Branch name, address, phone number, opening hours and an announcement. This is shown on the branch’s public page and printed at the top of tickets.</P>
      <Note>
        When someone leaves, press <L k="staff.remove" /> on the branch’s staff page, or revoke their role on the restaurant’s accounts page, so they can no
        longer manage or operate the branch. Only <L k="role.admin" /> and above can change branch settings; only <L k="role.manager" /> and{' '}
        <L k="role.superuser" /> can change restaurant-level items such as the branch price.
      </Note>
      <P>Your restaurant is ready to operate. Read the branch operation guide to see how a branch runs day to day.</P>
    </>
  )
}
